import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="min-h-screen bg-bg-main flex items-center justify-center px-6">
      <div className="text-center">
        <div className="text-[72px] mb-4">🙏</div>
        <h1 className="font-display text-4xl font-bold text-text-dark mb-3">
          Page Not Found
        </h1>
        <p className="text-text-gray text-lg mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist. Let's get you back on the path.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 py-3 px-6 rounded-xl bg-brand-dark text-white font-semibold no-underline transition-transform duration-150 hover:scale-[1.02]"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </Link>
      </div>
    </div>
  )
}
